import { Link, useLocation } from "react-router-dom";
import { ArrowRight, ChevronRight } from "lucide-react";
import "./mega-menu.css";

/** True when `pathname` is the link's page or a page beneath it (e.g. a product inside that subcategory). */
export function isActiveMenuHref(pathname, href) {
  if (!href || href === "/products") return false;
  const path = pathname.replace(/\/+$/, "");
  const target = href.split(/[?#]/)[0].replace(/\/+$/, "");
  return path === target || path.startsWith(`${target}/`);
}

/**
 * One product link in the Products mega menu — the same component for every category, fed straight from the existing
 * mega-menu link objects (`{ label, href | url }`); no product data is duplicated. All states are CSS (mega-menu.css,
 * `.mm-plink*`): chevron → arrow, 3–4px shift, blue text, faint tint and 2px left accent on :hover / :focus-visible,
 * and a quieter persistent version via aria-current="page" for the page being viewed. `index` staggers the entrance.
 */
export default function MegaMenuProductLink({ link, index = 0, onClick, testId }) {
  const { pathname } = useLocation();
  const href = link.href || link.url || "/products";
  const active = isActiveMenuHref(pathname, href);
  return (
    <li className="mm-plink-item" style={{ "--mm-i": index }}>
      <Link to={href} onClick={onClick} data-testid={testId} aria-current={active ? "page" : undefined} className="mm-plink">
        <span className="mm-plink-arrow" aria-hidden="true">
          <ChevronRight className="mm-plink-chev" strokeWidth={2.25} />
          <ArrowRight className="mm-plink-to" strokeWidth={2.25} />
        </span>
        <span className="mm-plink-label">{link.label}</span>
      </Link>
    </li>
  );
}
